module.exports = {
    dashboard: "Dashboard",
    voltage_profile: "Voltage profile",
    current_profile: "Current profile",
    active_power_profile: "Active power profile",
    reactive_power_profile: "Reactive power profile",
    apparent_power_profile: "Apparent power profile",
    energy_import_profile: "Energy import profile",
    energy_export_profile: "Energy export profile",
    realtime_voltage: "Real time voltage profile",
    realtime_current: "Real time current profile",
    realtime_active_power: "Real time active power profile",
    realtime_reactive_power: "Real time reactive power profile",
    realtime_apparent_power: "Real time apparent power profile",
    realtime_energy_import_profile: "Real time energy import profile",
    realtime_energy_export_profile: "Real time energy export profile",
    hourly_active_energy: "Hourly active energy",
    daily_active_energy: "Daily active energy",
    monthly_active_energy: "Monthly active energy",
    hourly_reactive_energy: "Hourly reactive energy",
    daily_reactive_energy: "Daily reactive energy",
    monthly_reactive_energy: "Monthly reactive energy",
    appliances_imprints: "Appliances imprints",
    appliances_energy: "Appliances energy",
    appliances_timeline: "Appliances timeline",
    appliances_run_profile: "Appliances run profile",
    imprints_map: "Appliances imprints map",
    edit_profile: "Edit profile",
    dashboard_settings: "Dashboard settings",
    statistics_report: "Statistics report",
    graphs_types: "Graphs types",
    active_energy_report: "Active energy report",
    reactive_energy_report: "Reactive energy report",
    location: "Location",
    local_change_password: "Change local authentication password",
    monitoring: "Monitoring",
    phase_selection: "Phase selection",
    appliance_properties: "Appliance properties",
    energy_edit: "Energy settings",
    dashboard_merito_recognition: "Dashboard",
    dashboard_disconnector: "Disconnector dashboard",
    dashboard_precision: "Applied Precision Dashboard",
    disconnector_timeline: "Timeline",
    disconnector_energy_profile: "Energy profile",
    lora_settings: "LoRa settings",
    basic: "Basic",
    details: "Details",
    data: "Data",
    basic_settinsg: "Basic settings",
    details_settings: "Details settings",
    data_structure_settinsg: "Data structure settings",
    timers: "Timers",
    energy_scalers: "Energy scales",
    radio: "Radio",
    create_first_test_case: "Create your first test case",
    add_new_test_case: "Add new test case",
    edit_test_case: "Edit test case",
    generator: "Generator",
    test_conditions: "Test conditions",
    accutest_profile: "Test profile",
    no_test_was_performed: "No test was performed",
    test_case: "Test case",
    relative_error_chart: "Chart of relative error over test cases",
    accutest_results: "Tests results",
    accutest_testing: "Testing process",
    start_testing_process: "Start testing process",
    test_case_result: "Result of test case",
    testing_in_progress: "Testing in progress",
    start_another_testing_process: "Start another testing process",
    integration: "Integration",
    generated: "Gnerated",
    expiration: "Expiration",
    token: "Token",
    note: "Note",
    token_validity: "Token validity",
    valid_tokens: "Valid tokens",
    invalid_tokens: "Invalid tokens",
    generate_first_token: "Generate first token",
    active_energy_15min: "Active energy in 15 minutes",
    maximum_active_energy_15min: "Maximum active power in 15 minutes",
    wifi_settings: "WiFi settings",
    device_settings: "Device settings",
    report: "Application Report",
    controller_state: "Application Controller relay state",
    no_disconnector_selected: "No disconnector selected",
    controller_timeline: "Application Controller timeline",
    rising_shapes: "Rising shapes of appliances",
    falling_shapes: "Falling shapes of appliances",
    firmware_upgrade: "Firmware upgrade",
    firmware_up_to_date: "Firmware is up to date",
    firmware_upgrade_available: "Upgrade available",
    firmware_not_available: "Upgrade not available",
    settings: "Settings",
    new_switch: "New switch",
    map: "Map",
    upload_new_map: "Upload your new map",
    control_map: "Control map",
    uploading: "Uploading",
    loading: "Loading",
    notifications: "Notifications",
    add_notification_pair: "Add notification pair",
    paired_notifications: "Paired notifications",
    notify_device_status: "Device status",
    notify_anomaly: "Anomaly",
    anomaly_models: "Anomaly models",
    vector_chart: "Vector Diagram",
    harmonics_chart: "Harmonics chart",
    wavefrom_chart: "Waveform chart",
    meters_list: "Meters list",
    meter_add: "Add meter",
    meter_tests: "Meter test results",
    user_manager: "Application UserManager",
    select_group: "Devices group"
}